import { Form, Input, Select } from "antd";
import React, { useEffect } from "react";
const { Option } = Select;

const AvrageBasePayFilter = () => {
    const [form] = Form.useForm();
    const [formValues, setFormValues] = React.useState({});

    const handleChange = (key, value) => {
        setFormValues((prev) => ({ ...prev, [key]: value }))
    }

    const onSubmit = (values) => {
        console.log(values)
    }

    useEffect(() => {
        form.submit()
    }, [formValues])

    return <Form
        layout="inline"
        form={form}
        onFinish={onSubmit}
    >

        <Form.Item
            label="Location"
            name={'location'}

        >
            <Select
                defaultValue="All"
                style={{ width: "100%", minWidth: "150px" }}
                onChange={(value) => handleChange("location", value)}
            >
                <Option value="All">All</Option>
                <Option value="Delhi">Delhi</Option>
                <Option value="Mumbai">Mumbai</Option>
            </Select>
        </Form.Item>
        <Form.Item
            label="Job Title"
            name={'jobTitle'}
        >
            <Select
                defaultValue="All"
                style={{ width: "100%", minWidth: "150px" }}
                onChange={(value) => handleChange("jobTitle", value)}
            >
                <Option value="All">All</Option>
                <Option value="Developer">Developer</Option>
                <Option value="Manager">Manager</Option>
            </Select>
        </Form.Item>
        <Form.Item
            label="Department"
            name={'department'}
        >
            <Select
                defaultValue="All"
                style={{ width: "100%", minWidth: "150px" }}
                onChange={(value) => handleChange("department", value)}
            >
                <Option value="All">All</Option>
                <Option value="Engineering">Engineering</Option>
                <Option value="HR">HR</Option>
            </Select>
        </Form.Item>
    </Form>
}

export default AvrageBasePayFilter;